import breadcrumb from './breadcrumb/index'
import egrid from './egrid/index'
import hamburger from './hamburger/index'
import epagination from './epagination/index'
import scrollBar from './scrollBar/index'

import cmsTree from './cmsComponents/cmsTree.vue'
import cmsSiteTree from './cmsComponents/cmsSiteTree.vue'//站点树插件
import qrCode from './qrCode/qrCode/index.vue'//站点树插件
import cmsSiteDialog from './cmsComponents/cmsSiteDialog.vue'
import cmsDepartment from './cmsComponents/cmsDepartment.vue'
import cmsInput from './pagecomponents/cmsInput.vue'//横向标签组件
import cmsPagination from './pagecomponents/cmsPagination.vue'//cms分页
import cmsButton from './pagecomponents/cmsButton.vue'//cms图标按钮组件
import cmsBack from './pagecomponents/cmsBack.vue'//cms返回
import cmsUpload from './pagecomponents/cmsUpload.vue'//cms返回
import cmsContent from './pagecomponents/cmsContent.vue'//cms返回
import dateTimeToDate from './code/dateTimeToDate'
import backTop from './backTop'
import viewFiles from './viewFiles'
import filesUpload from './filesUpload'
import groupList from './groupList'
import groupLevel3 from './groupLevel3'
import reportForm from './reportForm/index'
//视频组件
import videoUpload from './VideoUpload/index'
import videoView from './VideoView/index'
//图片组件
import imageUpload from './ImageUpload/index'

// import cmsPictruesItems from './pagecomponents/cmsPictruesItems.vue'//cms返回
import cmsEditor from './pagecomponents/cmsEditor.vue'
import cmsFileUpload from './pagecomponents/cmsFileUpload.vue'
import cmsExportUpload from './pagecomponents/cmsExportUpload.vue'
import cmsMultipleUpload from './pagecomponents/cmsMultipleUpload.vue'
import appointViewWorFlow from './workFlow/appointViewWorkFlow'
import popShow from './code/popShow'
import operations from './operateColumn/operations'
import selfColumn from '@/components/column/self-column'
// 这里是重点
const components = {
  install: function(Vue) {
    Vue.component('breadcrumb', breadcrumb)
    Vue.component('egrid', egrid)
    Vue.component('hamburger', hamburger)
    Vue.component('epagination', epagination)
    Vue.component('scrollBar', scrollBar)
    Vue.component('cmsSiteTree',cmsSiteTree);
    Vue.component('cmsTree', cmsTree);
    Vue.component('cmsDepartment',cmsDepartment);
    Vue.component('cmsSiteDialog', cmsSiteDialog);
    Vue.component('cmsInput', cmsInput);
    Vue.component('cmsPagination', cmsPagination);
    Vue.component('cmsButton', cmsButton);
    Vue.component('cmsBack', cmsBack);
    Vue.component('qrCode', qrCode);
    Vue.component('cmsEditor', cmsEditor);
    Vue.component('cmsFileUpload',cmsFileUpload);
    Vue.component('cmsUpload', cmsUpload);
    Vue.component('cmsContent', cmsContent);
    // Vue.component('cmsPictruesItems', cmsPictruesItems);
    Vue.component('cmsExportUpload',cmsExportUpload);
    Vue.component('cmsMultipleUpload',cmsMultipleUpload);
    Vue.component('appointViewWorFlow',appointViewWorFlow);
    Vue.component('popShow',popShow);
    Vue.component('operations',operations);
    Vue.component('dateTimeToDate',dateTimeToDate);
    Vue.component('backTop',backTop);
    Vue.component('selfColumn',selfColumn);
    Vue.component('viewFiles',viewFiles);
    Vue.component('filesUpload',filesUpload);
    Vue.component('groupList',groupList);
    Vue.component('groupLevel3',groupLevel3);
    Vue.component('reportForm',reportForm);
    Vue.component('viewUpload',videoUpload);
    Vue.component('VideoView',videoView);
    Vue.component('ImageView',imageUpload);
  }
}

// 导出组件
export default components
